<mat-dialog-content>
  <lemon-dialog-header>
    {{ lisaa ? 'Lisää sarake' : 'Muokkaa saraketta ' + sarake?.nimi }}
  </lemon-dialog-header>

  <form novalidate style="margin: 0">
    <div style="padding-left: 3em; padding-right: 3em; padding-bottom: 1em">
      <mat-checkbox #sarakeAktiivinenCheckbox [formField]="lomake.aktiivinen">Aktiivinen</mat-checkbox>

      <mat-form-field style="margin: 1.5em 0">
        <mat-label>Sarakkeen nimi</mat-label>
        <input type="text" #sarakkeenNimiInput matInput [formField]="lomake.nimi" data-lpignore="true" />
        @if (naytaVirhe(lomake.nimi, 'required')) {
          <mat-error>Nimi puuttuu</mat-error>
        }
      </mat-form-field>

      <table>
        <tbody>
          @for (tila of lomake.tilat; track tila; let i = $index) {
            <tr>
              <td style="font-size: 30px; padding: 0 5px" class="light-blue-text">{{ i + 1 }}</td>
              <td>
                <mat-form-field style="width: 175px">
                  <mat-label>Tilan nimi</mat-label>
                  <input #tilanNimiInput type="text" matInput [formField]="tila.nimi" data-lpignore="true" />
                  @if (naytaVirhe(tila.nimi, 'required')) {
                    <mat-error>Nimi puuttuu</mat-error>
                  }
                </mat-form-field>
              </td>
              <td>
                <mat-form-field style="width: 175px">
                  <mat-label>Tilan kuvaus</mat-label>
                  <input type="text" matInput [formField]="tila.kuvaus" data-lpignore="true" />
                  @if (naytaVirhe(tila.kuvaus, 'required')) {
                    <mat-error>Kuvaus puuttuu</mat-error>
                  }
                </mat-form-field>
              </td>
              <td>
                <mat-form-field style="width: 175px">
                  <mat-label>Tilan väri</mat-label>
                  <mat-select [class]="tila.vari().value()" style="font-weight: bold" [formField]="tila.vari">
                    <mat-option [value]="null"><span style="font-weight: bold">Oletus</span></mat-option>
                    <mat-option value="red-text"><span style="font-weight: bold" class="red-text">Punainen</span></mat-option>
                    <mat-option value="blue-text"><span style="font-weight: bold" class="blue-text">Sininen</span></mat-option>
                    <mat-option value="light-blue-text"><span style="font-weight: bold" class="light-blue-text">Vaalean sininen</span></mat-option>
                    <mat-option value="yellow-text"><span style="font-weight: bold" class="yellow-text">Keltainen</span></mat-option>
                    <mat-option value="green-text"><span style="font-weight: bold" class="green-text">Vihreä</span></mat-option>
                    <mat-option value="purple-text"><span style="font-weight: bold" class="purple-text">Violetti</span></mat-option>
                    <mat-option value="light-gray-text"><span style="font-weight: bold" class="light-gray-text">Harmaa</span></mat-option>
                  </mat-select>
                </mat-form-field>
              </td>
              <td>
                <mat-checkbox style="margin-left: 15px" [formField]="tila.oletus">Oletus</mat-checkbox>
              </td>
            </tr>
          }
        </tbody>
      </table>

      <app-secondary-button #lisaaButton [disabled]="!lomake.aktiivinen().value()" (click)="lisaaTila()" actionId="Lisää tila (kirjanpitäjän sarakkeen muokkaus)" matIcon="add"> Lisää tila </app-secondary-button>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions style="padding-left: 3em; padding-right: 3em">
  <app-secondary-button mat-dialog-close actionId="Kirjanpitäjän sarakkeen muokkaus: Peruuta ja sulje dialog">Peruuta</app-secondary-button>
  <app-primary-button (click)="tallenna()" actionId="Kirjanpitäjän sarake tallennettu" [actionContext]="[$any(lomake().value())]">Tallenna</app-primary-button>
</mat-dialog-actions>
